
// src/context/cacheUtils.js
export async function clearBoardCaches(boardId) {
  try {
    const cache = await caches.open('api-cache');

    await Promise.all([
      cache.delete(`/aac/api/tiles.php?board_id=${boardId}`),
      cache.delete(`/aac/api/getconfig.php?id=${boardId}`),
    ]);

    localStorage.removeItem(`boardCacheAt:${boardId}`);
  } catch (e) {
    console.debug('Failed to clear board caches', e);
  }
}

